import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Radium from 'radium';

@Radium
class PlayPause extends Component {
  static contextTypes = {
    isPlaying: PropTypes.bool,
    playPause: PropTypes.func
  };

  _handlePlayPause = () => {
    this.context.playPause();
  };

  styles() {
    return {
      playerButtons: {
        display: 'flex',
        flexDirection: 'row',
        padding: '10px',
        alignItems: 'center',
        justifyContent: 'center'
      },
      playIcon: {
        cursor: 'pointer',
        borderLeft: '14px solid #a1a5a8',
        borderTop: '10px solid transparent',
        borderBottom: '10px solid transparent'
        // marginRight: '35px',
      },
      playIconPlaying: {
        borderLeft: '14px solid #0abff1'
      },
      playIconPaused: {
        borderLeft: '14px solid #a1a5a8'
      },
      pauseIcon: {
        cursor: 'pointer',
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center'
      },
      pauseBar: {
        height: '20px',
        width: '4px',
        margin: '0 2px 0',
        background: '#a1a5a8',
        display: 'block'
      },
      discardIcon: {
        cursor: 'pointer'
      }
    };
  }

  render() {
    const styles = this.styles();
    return (
      <div style={styles.playerButtons}>
        {this.context.isPlaying ? null : (
          <div style={[styles.playIcon, styles.playIconPaused]} onClick={this._handlePlayPause} />
        )}
        {this.context.isPlaying ? (
          <div style={[styles.pauseIcon]} onClick={this._handlePlayPause}>
            <span style={styles.pauseBar} />
            <span style={styles.pauseBar} />
          </div>
        ) : null}
      </div>
    );
  }
}

export default PlayPause;
